import { inject, Injectable } from '@angular/core';
import { ApplicantSearchClient, ApplicantSearchResponse } from 'api-clients/applicant-api-client';
import { SearchSanitizerService } from 'src/shared/search-sanitizer.service';
import { ApplicantResult } from '../applicant.result.model';

@Injectable()
export class SearchService {
  readonly #applicantSearchClient = inject(ApplicantSearchClient);
  readonly #searchSanitizerService = inject(SearchSanitizerService);

  async search(searchText: string): Promise<{ applicants: ApplicantResult[], numFound: number }> {
    const result = await this.#applicantSearchClient.applicantSearchGet(this.#searchSanitizerService.sanitize(searchText), 8, null);

    return {
      applicants: result.docs.map(doc => this.#applicantMatchToApplicantResult(doc)),
      numFound: result.numFound,
    };
  }

  #applicantMatchToApplicantResult(result: ApplicantSearchResponse): ApplicantResult {
    const applicantResult: ApplicantResult = {
      id: result.applicantId,
      name: result.displayName,
      address: {
        firstLine: result.addressLine1,
        cityStateZip: `${result.city} ${result.stateCode} ${result.zipCode} `,
      },
      assignedUser: `${result.assignedFirstName} ${result.assignedLastName}`,
      csrUser: `${result.csrFirstName} ${result.csrLastName}`,
      agency: result.ownerOrgName,
      status: result.applicantType,
      isCommercial: result.isCommercial,
      highlights: result.matchedValues?.map(mv => ({
        key: mv.key && `${mv.key}:`,
        value: mv.value.join(', '),
      })),
    };

    return applicantResult;
  }
}
